import React, {Component} from "react";
import { observer } from "mobx-react";
import {
    fn_getListOrderSearchView,fn_setListOrderSearchView,
    fn_getListSearchKey,
    fn_hide_search_list, fn_list_search,
    fn_setListSearchKey, fn_setListSearchView
} from "../../../function/FnBodySearch";

@observer
class OrderSearchAreaView extends Component {
    render() {

        const { rootStore } = this.props;

        return (
            <div> 
                <div className={fn_getListOrderSearchView(rootStore)?"bg":"hide"}
                    onClick={event => {fn_setListOrderSearchView(rootStore, !fn_getListOrderSearchView(rootStore))}}>
                </div>
                <div className="layer_comm layer_search2">
                    <div className="layer_content">
                        <div className="article_search">
                            <div className="section_search_header">
                                <div className="box_search clear_g">
                                    <div className={"bg_box_search "+(fn_getListOrderSearchView(rootStore)===true?"show":"hide")} onClick={event => {
                                        fn_setListOrderSearchView(rootStore, !fn_getListOrderSearchView(rootStore))
                                    }}></div>
                                    <div className="select">
                                        <button type="button"
                                                onClick={event => fn_setListSearchView(rootStore)}
                                        ><span>{fn_getListSearchKey(rootStore).val}</span></button>
                                        <ul className={"layer "+(fn_getListOrderSearchView(rootStore)===true?"open":"")}>
                                            <li>
                                                <button type="button"
                                                        onClick={event=>fn_setListSearchKey(rootStore,'mobileOrderNo', '채널 주문번호')}
                                                >채널 주문번호</button>
                                            </li>
                                            <li>
                                                <button type="button"
                                                        onClick={event=>fn_setListSearchKey(rootStore,'orderNo', '포스 주문번호')}
                                                >포스 주문번호</button>
                                            </li>
                                            <li>
                                                <button type="button"
                                                        onClick={event=>fn_setListSearchKey(rootStore,'orderAmount', '주문금액')}
                                                >주문금액</button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="search">
                                        <input type="text" value={rootStore.searchStore.getSearchVal}
                                            onChange={event=>rootStore.searchStore.setSearchVal(event.target.value)}
                                            onKeyPress= {(e) => {if(e.key === 'Enter') fn_list_search(rootStore) }}
                                        />
                                        <button type="submit" className="btn_search"
                                            onClick={event=>fn_list_search(rootStore)}
                                        >검색</button>
                                        <button type="button" className="btn_layer_close"
                                            onClick={event=>fn_hide_search_list(rootStore)}
                                        ><span>닫기</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default OrderSearchAreaView;